<ng-container *ngIf=" item && filtersIcon(item.brandId) && hasValidIcon(item.icon) ">
  <span class="icon_expansion" [style]=" {'background-position': ('-' + getPositionSprite(item.icon).x + 'px') + ' ' +( '-' + getPositionSprite(item.icon).y + 'px') }"></span>
</ng-container>